import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import TableHeader from "../../Datatable/Header/Index";
import PaginationComponent from "../../Datatable/Pagination/Index";
import Search from "../../Datatable/Search/Index";
import UseFullPageLoader from "../../FullPageLoader/UseFullPageLoader";



const ListContact = () => {
    document.title = "DirtMap - Contact Index";
    const [loader, showLoader, hideLoader] = UseFullPageLoader();

    const [loading, setLoading] = useState(true);
    const [contactList, setContactList] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState("");
    const [sorting, setSorting] = useState({ field: "", order: "" });

    const ITEMS_PER_PAGE = 10;

    const headers = [
        { name: "No#", field: "id", sortable: false },
        { name: "Name", field: "name", sortable: true },
        { name: "Email", field: "email", sortable: true },
        { name: "Phone Number", field: "phone", sortable: true },
        { name: "Message", field: "message", sortable: true },
        { name: "Action", field: "action", sortable: false }
    ];

    const getData = () => {
        axios.get(`/api/contact/list`).then(res => {
            if (res.data.result) {
                hideLoader();
                setContactList(res.data.result);
            }
            hideLoader();
            setLoading(false);
        });
    }

    useEffect(() => {
        showLoader();
        getData();
        hideLoader();
    }, []);

    const contactData = useMemo(() => {
        let computedContactList = contactList;
        // return computedContactList;
        if (search) {
            computedContactList = computedContactList.filter(
                contactList =>
                    contactList.name.toLowerCase().includes(search.toLowerCase()) ||
                    contactList.email.toLowerCase().includes(search.toLowerCase())
            );
        }

        setTotalItems(computedContactList.length);

        //sorting comment
        if (sorting.field) {
            const reversed = sorting.order === "asc" ? 1 : -1;
            computedContactList = computedContactList.sort(
                (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])

            );
        }

        return computedContactList.slice(

            (currentPage - 1) * ITEMS_PER_PAGE,
            (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE

        );
    }, [contactList, currentPage, search, sorting]);

    const deleteContact = (e, id) => {
        showLoader();
        e.preventDefault();
        //const thisclicked = e.currentTarget;
        //thisclicked.innerHtml = 'Deleting';
        axios.delete(`/api/delete/contact/${id}`).then(res => {
            if (res.data.status_code === 200) {
                hideLoader();
                swal('success', res.data.message, 'success');
                getData();
                //thisclicked.closest('tr').remove();
            } else if (res.data.status_code === 404) {
                hideLoader();
                swal('error', 'No page id found', 'error');
                //thisclicked.innerHtml = 'Delete';
            }
        });

    }

    var LISTCONTACT_HTMLTABLE = "";
    if (loading) {
        return <div className="fp-container"><img src={"/images/spinner.gif"} className="fp-loader" alt="loading" /></div>;
    } else {
        LISTCONTACT_HTMLTABLE =
            contactData.map((item, index) => {
                const created_at = new Date(item.created_at);

                return (<tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>{item.name}</td>
                    <td>{item.email}</td>
                    <td>{item.phone}</td>
                    <td>{item.message}</td>
                    <td className="list-action-sec">
                        <Link to={`/admin/contact/detail/${item.id}`} className="btn btn-info btn-circle btn-sm mr-2" title="View contact details">
                            <i className="fa fa-eye"></i>
                        </Link>
                        <button type="submit" onClick={(e) => deleteContact(e, item.id)} className="btn btn-danger btn-circle btn-sm">
                            <i className="fas fa-trash"></i>
                        </button>
                    </td>
                </tr>)
            });
    }


    return (
        <div className="container-fluid">
            <div className="card shadow mb-4">
                <div className="card-header py-3">
                    <div className="row align-items-center">
                        <div className="col-sm-5">
                            <h4 className="card-title mb-0">Contact List</h4>
                        </div>
                        {/* <div className="col-sm-7">
                            <div className="btn-toolbar float-right" role="toolbar" aria-label="Toolbar with button groups">
                                <Link to="/admin/page/add" className="btn btn-success ml-1" data-toggle="tooltip" title="Create New" data-original-title="Create New"><i className="fa fa-plus-circle"></i> Add More</Link>
                            </div>
                        </div> */}
                    </div>
                </div>
                <div className="col-sm-12 mt-3">
                    <Search
                        onSearch={(value) => {
                            setSearch(value);
                            setCurrentPage(1);
                        }}
                    />
                </div>
                <div className="card-body">

                    <div className="table-responsive">

                        <table className="table table-bordered" id="dataTable" width="100%">
                            <TableHeader headers={headers}
                                onSorting={(field, order) =>
                                    setSorting({ field, order })}
                            />

                            <tbody>

                                {LISTCONTACT_HTMLTABLE}

                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <div className="col-sm-12 col-md-9">
                            {/* <div className="dataTables_info" id="dataTable_info" role="status" aria-live="polite">Showing 1 to 1 of 1 entries</div> */}
                        </div>
                        <div className="col-sm-12 col-md-3">
                            <PaginationComponent
                                total={totalItems}
                                itemsPerPage={ITEMS_PER_PAGE}
                                currentPage={currentPage}
                                onPageChange={page => setCurrentPage(page)}
                            />
                        </div>
                    </div>
                </div>
            </div>
            {loader}
        </div>
    )
}

export default ListContact;